import React from 'react'

const Divider = ({ children }) => {
  return (
    <div className="inline-flex items-center justify-center w-full relative">
        <hr className="w-full h-1 my-8 bg-gray-200 border-0 rounded" />
        <div className="absolute px-4 -translate-x-1/2 bg-white left-1/2 ">
            <p className="text-xl font-bold leading-tight tracking-tight text-black text-left">{children}</p>
        </div>
    </div>
  )
}

export default Divider;